import { useEffect, useState } from 'react'
import { cn } from '@/lib/utils'

/**
 * Watch gallery: one large frame and a strip of thumbnails. No lightbox, no
 * carousel arrows — the photographs are square-on product shots and the fastest
 * way to compare them is to click.
 */
export function Gallery({ images, alt }: { images: string[]; alt: string }) {
  const shots = images.filter(Boolean)
  const [active, setActive] = useState(0)

  // A different watch means a different set of shots — go back to the first.
  useEffect(() => setActive(0), [shots[0]])

  if (!shots.length) return null

  return (
    <div className="flex flex-col gap-3" data-upbo-type="container" data-upbo-label="Watch gallery">
      <div className="overflow-hidden rounded-squircle bg-surface-2 aspect-square">
        <img
          key={shots[active]}
          src={shots[active]}
          alt={alt}
          className="h-full w-full object-cover animate-fade-in"
        />
      </div>

      {shots.length > 1 && (
        <div className="grid grid-cols-4 gap-3">
          {shots.map((src, i) => (
            <button
              key={src + i}
              type="button"
              onClick={() => setActive(i)}
              aria-label={`${alt} — ${i + 1}`}
              aria-current={i === active}
              className={cn(
                'overflow-hidden rounded-squircle aspect-square bg-surface-2 border transition-colors',
                i === active ? 'border-text' : 'border-transparent hover:border-border-strong',
              )}
            >
              <img src={src} alt="" loading="lazy" className="h-full w-full object-cover" />
            </button>
          ))}
        </div>
      )}
    </div>
  )
}
